import { render, staticRenderFns } from "./sch_jyqkystj.vue?vue&type=template&id=581fe807&scoped=true"
import script from "./sch_jyqkystj.vue?vue&type=script&lang=js"
export * from "./sch_jyqkystj.vue?vue&type=script&lang=js"
import style0 from "./sch_jyqkystj.vue?vue&type=style&index=0&id=581fe807&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581fe807",
  null
  
)

export default component.exports